import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=b9a7b704&scoped=true&"
import script from "./MenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./MenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=b9a7b704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a7b704",
  null
  
)

export default component.exports